import { useTranslation } from "react-i18next";

function Terms() {
  const { t } = useTranslation();
  return (
    <main className="page p-6 max-w-4xl mx-auto space-y-6">
      <header>
        <h1 className="text-3xl font-bold">{t("pages.terms.title")}</h1>
        <p className="text-sm text-slate-600 mt-1">
          {t("pages.terms.updated")}
        </p>
      </header>

      <section
        className="prose"
        dangerouslySetInnerHTML={{ __html: t("pages.terms.html") }}
      />
    </main>
  );
}

export default Terms;
